import React, { useState } from 'react';
import { List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import Dropzone from 'react-dropzone-uploader';

import { FormatDateTime } from '../../utils/helpers';
import { Wrapper } from './styles';

import 'react-dropzone-uploader/dist/styles.css';

const FileDropZone = () => {
  const maxSize = 5.12e8;
  const [fileNames, setFileNames] = useState([]);

  // specify upload params and url for your files
  const getUploadParams = ({ meta }) => {
    return { url: 'api/documentcatalog/uploads' };
  };

  const handleChangeStatus = ({ meta, remove }, status) => {
    if (status === 'done') {
      setFileNames(old => [...old, meta]);
      remove();
    }
    console.log(status, meta, meta.name);
  };

  return (
    <Wrapper className="upload">
      <Dropzone
        getUploadParams={getUploadParams}
        onChangeStatus={handleChangeStatus}
        maxSizeBytes={maxSize}
        styles={{
          dropzoneReject: { borderColor: 'red', backgroundColor: '#DAA' },
        }}
      />

      <List style={{ maxHeight: '100%', overflow: 'auto' }}>
        {fileNames.map((file, index) => (
          <ListItem key={index}>
            <ListItemAvatar>
              <CheckCircleOutline color="secondary" />
            </ListItemAvatar>
            <ListItemText
              primary={`${file.name} - Uploaded ${FormatDateTime(file.uploadedDate)}`}
            />
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
};

export default FileDropZone;
